module.exports = __webpack_public_path__ + "img/user-1.125c61d7.png";